/**
 * Directive: inputField
 */
angular.module('acme.common.directive.inputField', [
  'acme.common.directive.fieldFocus',
  'acme.common.directive.capitalize'
])
.directive('inputField', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/inputField/inputField.tpl.html',
      scope: {
        type: '@',
        name: '@',
        label: '@',
        addon: '@',
        icon: '@',
        useFullWidth: '@', // Used in conjunction with maxlength to prevent constrained width
        model: '=',
        disabled: '=',
        useCancel: '@',
        setFieldFocus: '@setfieldfocus',
        fieldFocusTimeout: '@',
        maxLength: '@maxlength',
        hasAddon: '@hasaddon',
        hideLabel: '@hidelabel',
        validTest: '=validtest',
        errorMessage: '=errormessage',
        isPanelGroup: '@ispanelgroup',
        placeholderValue: '@placeholdervalue',
        required: '@'
      },
      link: function($scope, $element, $attrs) {
        // Modified after controller runs

      },

      controller: ['$scope', function($scope) {

        $scope.inputField = {

          setFieldFocus: $scope.setFieldFocus,
          placeholder: $scope.placeholderValue || '',
          groupTypeClass: ($scope.isPanelGroup) ? 'panel-form-group' : 'form-group',
          fieldFocusTimeout: ($scope.fieldFocusTimeout) ? $scope.fieldFocusTimeout : 0,

          label: $scope.label || ($scope.placeholderValue || ''),

          init: function() {},

          checkValid: function() {
            return ($scope.validTest !== undefined) ? $scope.validTest : true;
          },

          clear: function(name) {
            $scope.model = '';
            if (name) {
              $('#input-' + name + (($scope.hasAddon) ? '-addon' : '')).focus();
            }
          }

        };

        $scope.inputField.init();

      }]

    };

}]);
